export enum PublicEventSsoMode {
  Undefined = 0,
  Introspection = 1,
  UserInfo = 2,
  AuthorizeUser = 3
}
